import { IPackingTypeMySuffix } from 'src/app/shared/model//packing-type-my-suffix.model';

import { ILoadingSubTypeDto, LoadingSubTypeDto } from 'src/app/shared/model/loading-subtype.model';
import { ModeOfConveyance } from './mode-of-conveyance.model';

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface ILoadingTypeMySuffix {
    id?: number;
    name?: string;
    subType?: string;
    isSubType?: boolean;
    activeStatus?: ActiveStatus;
    packingTypes?: IPackingTypeMySuffix[];
    lastModifiedBy?: string;
    createdByUserRole?: string;
    fromEffectiveDate?: string;
    loadingSubTypeDto?: ILoadingSubTypeDto[];
    packingTypeDTOs?: IPackingTypeMySuffix[];
    modeOfConveyances?: ModeOfConveyance[];
    loadingTypeAr?: ILoadingTypeMySuffix[]
    isSubtypeShow?: boolean;
}

export class LoadingTypeMySuffix implements ILoadingTypeMySuffix {
    constructor(
        public id?: number,
        public name?: string,
        public subType?: string,
        public isSubType?: boolean,
        public activeStatus?: ActiveStatus,
        public packingTypes?: IPackingTypeMySuffix[],
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public fromEffectiveDate?: string,
        public loadingSubTypeDto?: ILoadingSubTypeDto[],
        public packingTypeDTOs?: IPackingTypeMySuffix[],
        public modeOfConveyances?: ModeOfConveyance[],
        public loadingTypeAr: ILoadingTypeMySuffix[] = [],
        public isSubtypeShow?: boolean
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
        this.isSubtypeShow = false;
    }
}

/* new loading DTO */

export interface ILoadingTypeDto {
    id?: number;
    name?: string;
    loadingSubTypeDto?: ILoadingSubTypeDto[];
    activeStatus?: ActiveStatus;
    packingTypeDTOs?: IPackingTypeMySuffix[];
    isSubType?: boolean;
    lastModifiedBy?: string;
    createdByUserRole?: string;
    lastModifiedByUserRole?: string;
    fromEffectiveDate?: string;
    modeOfConveyances?: ModeOfConveyance[];
    isCoolingRequired?: boolean;
    kindOfCargo?: string;
}

export class LoadingTypeDto implements ILoadingTypeDto {
    constructor(
        public id?: number,
        public name?: string,
        public loadingSubTypeDto: ILoadingSubTypeDto[] = [],
        public activeStatus?: ActiveStatus,
        public packingTypeDTOs?: IPackingTypeMySuffix[],
        public isSubType?: boolean,
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public lastModifiedByUserRole?: string,
        public fromEffectiveDate?: string,
        public modeOfConveyances?: ModeOfConveyance[],
        public isCoolingRequired?: boolean
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
        const subType = new LoadingSubTypeDto();
        this.loadingSubTypeDto.push(subType);
        this.isSubType = true;
    }
}
